<template>
	<div class="ms">
		<banners :sliders="banner_list" v-if="flag"></banners>
    <div class="lotto-content">
      <div class="lotto-list" >
        <div class="ll" v-for="lotto in lottos" >
          <div class="lotto-info"  @click="getLottoDetail(lotto.name,lotto.type,'history')">
            <div class="lotto-img">
              <div :class="lotto.name+'-img'"></div>
            </div>
            <div class="name-info">
              <div class="name">{{lotto.nickname}}</div>  
              <div class="periods">
                第<span v-if="lotto.endTime<0 && lotto.endTime !==-9999" style="color: #ff532e;">{{parseInt(lotto.curIssue)+1}}</span>
                  <span v-else style="color: #ff532e;">{{lotto.curIssue}}</span>期
              </div>
              <div class="info">
              每{{lotto.allCount[0]}}分钟一期，全天{{lotto.allCount[1]}}期<br>
              当前{{lotto.todayCount}}期，剩余{{lotto.allCount[1] - lotto.todayCount}}期
              </div> 
            </div>
            <div v-show="lotto.endTime>0 && lotto.endTime <= 3600" class="home-count-down">
              <countdown :countdownTime="lotto.endTime"></countdown>
            </div>
            <div v-show="(lotto.endTime<0 && lotto.endTime ==-9999) ||  lotto.endTime > 3600" class="home-count-down" >
                <span class="next-kaijiangzhong">待开盘</span>
                
            </div>
             <div v-if="lotto.endTime<0 && lotto.endTime !==-9999 " class="home-count-down" >
                <span class="next-kaijiangzhong">开奖中</span>   
            </div>
          </div>
          <div class="lotto-history">
            <div class="nums">
            <div v-if="lotto.endTime<0 && lotto.endTime !==-9999 ">
              <ul>              
                <img height="100%" style="margin-left:5%"  src="./../assets/piaog.gif"> 
              </ul>
            </div>
            <div v-else>
              <ul v-if="lotto.type == 'pk'">
                <li class="pk-ball" v-for="num in lotto.nums" :class="'pk'+num">{{num}}</li>
              </ul>
              <ul v-else-if="lotto.type == 'pc'">
              <li class="pc-ball home-pc">{{lotto.nums[0]}}</li>
              <span>+</span>
              <li class="pc-ball home-pc">{{lotto.nums[1]}}</li>
              <span>+</span>
              <li class="pc-ball home-pc">{{lotto.nums[2]}}</li>
              <span>=</span>
              <li :class="'pc-ball home-pc'+lotto.TotalBose">{{lotto.nums|pcCodeTotal}}</li> 
              </ul>
              <ul v-else>
                <li class="other-ball" v-for="num in lotto.nums">{{num}}</li>
              </ul>
            </div>
            </div>
            <div class="analyze">
              <span @click="getLottoDetail(lotto.name,lotto.type,'history')">开奖历史</span>|
              <span @click="getLottoDetail(lotto.name,lotto.type,'dewdrop')">露珠分析</span>|
              <span @click="getLongQueue(lotto.name)">冷热分析</span>|
              <span @click="getLottoDetail(lotto.name,lotto.type,'graphs')">走势图表</span>
            </div>
          </div>
        </div>
      </div>
      <div class="hot-lotto">
        <div class="hot-title">
          <span style="margin-left: 22px;">热门彩种</span><sup>HOT</sup><img style="float: right;margin: 12px 17px 0 0" src="./../assets/hot.png">
        </div>
        <div class="hot-content">
          <ul>
            <li v-for="lotto in hotlottos" @click="getLottoDetail(lotto.name,lotto.type,'synthesize')"><a ><div :class="lotto.name+'-img small-img'"></div></a><a >{{lotto.nickname}}</a></li>
          </ul>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
  import banners from '@/components/Banner'
  import countdown from '@/components/CountDown'
  import bus from '../assets/js/eventBus'
	export default {
    data() {
      return {
        banner_list: [],
        flag: false,
        lottos:this.$store.state.lottoList,
        LottoNames:'',
        hotlottos:this.$store.state.lottoList,
      }
    },
    filters:{
        pcCodeTotal(nums){
            if(nums){
                return parseInt(nums[0])+parseInt(nums[1])+parseInt(nums[2]);
            }
            return '';
        }
    },
    mounted:function () {
      let self = this; 
      let lottoName = this.$route.params.lottoName;
      let search = 1;
      self.LottoNames = lottoName
      bus.$on('search', function(msg) {
        search = 2;
        self.LottoNames = msg
        clearInterval(self.pankouCounter);
        self.panKouAjax(self,self.LottoNames,search);
        self.pankouCounter = setInterval(function () {
          self.panKouAjax(self,self.LottoNames,search);
        },self.$store.state.intervalTime);
      })
      if(self.LottoNames){
        search = 2;
      }
      self.getBanner(self);
      self.panKouAjax(self,self.LottoNames,search);
      clearInterval(this.pankouCounter);
      self.pankouCounter = setInterval(function () {
        self.panKouAjax(self,self.LottoNames,search);
      },self.$store.state.intervalTime);
    },
    destroyed:function () {
      clearInterval(this.pankouCounter);
    },
    methods: {
      getBanner(e) {
        this.$api.getBanner()
        .then(function(res) {
          if(res.data.length > 0){
            e.flag = true
            e.banner_list = res.data;
          }
        })
        .catch(function(res) {
          console.log('服务器加载异常');
        });
      },
      panKouAjax(e,LottoNames,search){
        this.$api.getKaiPan(
          {lottoName:LottoNames}
          )
        .then(function(res) {
          if(search == '1'){
            e.lottos = res.data;
          }else{
            e.lottos = res.searchdata;
          }
            e.hotlottos = res.data;
            if(!e.$store.state.search){
              e.$store.commit('setSearch',JSON.stringify(res.search));
            }
        })
        .catch(function(error){              
            console.log('服务器加载异常');
        });
      },
      getLottoDetail(lottoName,type,showFlag){        
        this.$router.push({name:'LottoDetail',path:'/LottoDetail',params:{lottoName:lottoName,type:type,showFlag:showFlag}});
      },
      getLongQueue(lottoName){
        this.$router.push({name:'LongQueue',path:'/LongQueue',params:{lottoName:lottoName}});
      }
    },
		components: {
      banners,
      countdown
		}
	}
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0;
	}
	.ms {
		width: 100%;
    height: 100%;
    position: relative;
	}
  .nums span {
    margin-left: 5px; 
    font-size: 18px;
    color:rgba(0,0,0,.5);
  }
  /*<1281的设备*/
  @media screen and (max-width: 1281px){
    .lotto-content {
      width: 1024px;
    }
    .name-info .name {
      font-size: 20px;
    }
    .lotto-info .home-count-down {
      right: 3%;
    }
    .hot-content ul li a{
      font-size: 14px;
    }
  }
  /*>=1281的设备*/
  @media screen and (min-width: 1281px){
    .lotto-content {
      width: 1280px;
    }
    .name-info .name {
      font-size: 24px;
    }
    .lotto-info .home-count-down {
      right: 7%;
    }
    .hot-content ul li a{
      font-size: 16px;
    }
  } 
  .lotto-content {
    margin: 0 auto;
    overflow: hidden;
  }
  .lotto-list {
    float: left;
    width: 73%;
  }
  .lotto-list > div {
    height: 227px;
    background-color: #ffffff;
    margin-top: 10px;
    margin-right: 5px;  
  }
  .ll {
    float: left;
    width: 49%;
  }
  .lotto-info {
    height: 113px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #999999;
    position: relative;
    cursor: pointer;
  }
  .lotto-img {
    height: 80px;
    margin:7% 0 0 6%; 
    float: left;
  }
  .lotto-img img {
    width: 80px;
    height: 80px;
  }
  .name-info {
    height: 80px;
    margin: 7% 0 0 4%;
    float: left;
  }
  .name-info .name {
    color: #333333;
    float: left;
  }
  .name-info .info {
    clear: both;
    padding-top: 14px;
  }
  .name-info .periods {
    float: left;
    margin-left: 12px;
  }
  .lotto-info .home-count-down {
    position: absolute;
    bottom: -2%;
  }
  .home-count-down {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #999999;
  }
  .lotto-history {
    height: 113px;
    position: relative;
  }
  .lotto-history .nums {
    height: 40px;
  }
  .lotto-history .nums ul {
    margin:5% 0 0 7%;
  }
  .nums li {
    text-align: center;
    margin-left: 5px;
    margin: left;
  }
  .lotto-history .analyze {
    width: 100%;
    margin:0 auto;
    color: #999999;
  }
  .lotto-history .analyze span{
    display: inline-block;
    width: 23%;
    height: 52px;
    line-height: 52px;
    text-align: center;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    color: #666666;
    cursor: pointer;
  }
  .hot-lotto {
    float: right;
    width: 27%;
    margin-top: 10px;
    background-color: #ffffff;
    padding-bottom: 50px;
    cursor: pointer;
  }
  .hot-title {
    width: 100%;
    height: 52px;
    background-color: #ffffff;
    font-family: PingFang-SC-Bold;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 52px;
    letter-spacing: 0px;
    color: #333333;
  }
  .hot-content {
    width: 100%;
    background-color: #ffffff;
    margin-top: 2px; 
    text-align: center;
  }
  .hot-content ul {
    width: 100%;
    list-style: none;
    margin: auto;
  }
  .hot-content ul li {
    width: 33%;
    height: 104px;
    display: inline-block;
    float: left;
    margin-top: 15px; 
    text-align: center;
  }
  .hot-content ul li a{
    text-decoration: none;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
    font-weight: normal;
    font-stretch: normal;
  }
  .hot-content ul li a img{
    width: 70px;
    height: 70px;
  }
  sup {
    margin-left: 5px; 
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 15px;
    letter-spacing: 0px;
    color: #ff3600;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue